import { create } from "zustand";

interface AppInitializationState {
  modelsInitialized: boolean;
  tokensInitialized: boolean;
  setModelsInitialized: (initialized: boolean) => void;
  setTokensInitialized: (initialized: boolean) => void;
  isAppInitialized: () => boolean;
  reset: () => void;
}

export const useAppInitializationStore = create<AppInitializationState>(
  (set, get) => ({
    modelsInitialized: false,
    tokensInitialized: false,
    setModelsInitialized: (initialized) =>
      set({ modelsInitialized: initialized }),
    setTokensInitialized: (initialized) =>
      set({ tokensInitialized: initialized }),
    isAppInitialized: () => {
      const { modelsInitialized, tokensInitialized } = get();
      return modelsInitialized && tokensInitialized;
    },
    reset: () =>
      set({
        modelsInitialized: false,
        tokensInitialized: false,
      }),
  }),
);
